import React, { useState, useEffect } from 'react'
import { Button } from 'reactstrap'
import { useSelector, useDispatch } from "react-redux"
import swal from 'sweetalert'
import captureVideoFrame from "capture-video-frame";
import EditingScreenShot from './EditingScreenShot';
import html2canvas from "html2canvas"
import { ConsoleView } from 'react-device-detect';
import * as Actions from "../../../store/actions"
import EventBus from "./editor/eventBus"
import Swal from 'sweetalert2';
import ToolStore, { POINTER, PEN, LINE, ELLIPSE, RECT, ARROW, NOTHING } from './editor/toolStore';

const ManualRomContainer = (props) => {
    const dispatch = useDispatch();
    const [Step, setStep] = useState(1);
    const [Angle, setAngle] = useState(0);
    const [IndexToEdit, setIndexToEdit] = useState(0);
    const [ImageToEdit, setImageToEdit] = useState("");
    const [ImageList, setImageList] = useState([]);
    const [IsEditorLoading, setIsEditorLoading] = useState(false);

    const [BSROMResult_ID1, setBSROMResult_ID1] = useState(0)
    const [BSROMResult_ID2, setBSROMResult_ID2] = useState(0)

    const [PatientName, setParientName] = useState("")
    const SelectedVideoForROM = useSelector(({ meeting }) => meeting.SelectedVideoForROM);

    console.log(PatientName,"PatientName")
    function captureFrame() {
        const frame = captureVideoFrame(SelectedVideoForROM, "png");
     
        const NameSpan = document.getElementById(`HoverThingy${parseInt(SelectedVideoForROM.replace("CHIME_VIDEO_TAG", "")) - 1}`)
        if(!NameSpan?.innerHTML){
            swal("Please select Enable ROM for a patient", "Enable ROM is not selected", "error")
            return
        }
        setParientName(NameSpan.innerHTML)
        if (frame.dataUri?.length < 10 || !frame.dataUri) {

            swal("Please instruct the patient to turn on their camera!", "Patient's camera is off, the screenshot cannot be taken", "error")
            return false
        }

        // return "/images/exerciseGirl.png"
        return frame.dataUri
    }

    function takingFirstImage() {

        const img = captureFrame()


        if (img) {
            setImageToEdit(img);
            setStep(2)

            EventBus.emit(EventBus.PICK_VERSION, 0);
            EventBus.emit(EventBus.TOOL_CHANGE, LINE)
        }


    }

    function takingSecondImage() {
        const img = captureFrame()

        if (img) {
            setImageToEdit(img);
            setStep(4)
        }
    }

    async function EditPicture() {
        setIsEditorLoading(true)
        document.getElementById("tools").style.visibility = "hidden"
        if(document.getElementById("MyNewCross")) document.getElementById("MyNewCross").style.visibility = "hidden"
        const canvas = await html2canvas(document.getElementById("theEditor"))
        document.getElementById("tools").style.visibility = "visible"
        if(document.getElementById("MyNewCross")) document.getElementById("MyNewCross").style.visibility = "visible"


        // console.log(canvas.toDataURL())
        const imgBase = canvas.toDataURL()

        let newArray = ImageList;
        newArray[IndexToEdit] = imgBase;

        setIsEditorLoading(false)

        setImageList(newArray)
        setStep(5)
        setImageToEdit("")
        setIndexToEdit(0)
        EventBus.emit(EventBus.PICK_VERSION, 0);
    }

    async function saveFirstScreenShot() {
        setIsEditorLoading(true)
        if(document.getElementById("MyNewCross")) document.getElementById("MyNewCross").style.visibility = "hidden"

        document.getElementById("tools").style.visibility = "hidden"
        const canvas = await html2canvas(document.getElementById("theEditor"))
        document.getElementById("tools").style.visibility = "visible"
        if(document.getElementById("MyNewCross")) document.getElementById("MyNewCross").style.visibility = "visible"


        // console.log(canvas.toDataURL())
        const imgBase = canvas.toDataURL()
        // alert(Angle)
        dispatch(Actions.startRomSessionWithImage(13, imgBase, Angle, true)).then((res) => {

            setBSROMResult_ID1(res.bSROMResultId)
        })
        // EventBus.emit(EventBus.PICK_VERSION, 0);
        setImageList([...ImageList, imgBase])
        setIsEditorLoading(false)
        setStep(3)
        setImageToEdit("")

    }

    async function saveSecondImage() {
        setIsEditorLoading(true)
        document.getElementById("tools").style.visibility = "hidden"
        if(document.getElementById("MyNewCross")) document.getElementById("MyNewCross").style.visibility = "hidden"
        
        const canvas = await html2canvas(document.getElementById("theEditor"))
        document.getElementById("tools").style.visibility = "visible"
        if(document.getElementById("MyNewCross")) document.getElementById("MyNewCross").style.visibility = "visible"


        // console.log(canvas.toDataURL())
        const imgBase = canvas.toDataURL()
        dispatch(Actions.SaveManualROM(Angle, imgBase)).then((res) => {
            setBSROMResult_ID2(res.bSROMResultId);
            dispatch(Actions.SaveROM(BSROMResult_ID1, res.bSROMResultId, null, PatientName))
            props.setStageHere(1)
            setIsEditorLoading(false)
            setStep(5)
            EventBus.emit(EventBus.PICK_VERSION, 0);
            setImageToEdit("")
        })
        setImageList([...ImageList, imgBase])
    }

    if (Step === 5) {
        return (
            <div className="ManualRomContainer" style={{ overflowY: "scroll" }}>
                <div className="TheSavedDiv">
                    <p className="Restart">
                        Range of motion Evaluation <span style={{ cursor: "pointer" }} onClick={() => {
                            setStep(1)
                            setImageToEdit("")
                            // setImageList([])
                            setIsEditorLoading(false)
                            props.exitManualRom()
                        }}>(Click here to restart again)</span>
                    </p>

                    {
                        ImageList.map((value, index) => {
                            return (
                                <div key={index} className="SavedMRA">
                                    <span
                                        onClick={() => {
                                            Swal.fire({

                                                imageUrl: value,
                                                imageWidth: 450,
                                                imageAlt: 'A tall image',
                                                showCloseButton: true,
                                                title: "Measurement",
                                                allowEscapeKey: true,
                                                allowOutsideClick: true,
                                            })
                                            // setImageToEdit(value)
                                            // setIndexToEdit(index)
                                            // setStep(6)
                                        }}
                                        className="theSavedImageContainer" style={{ backgroundImage: `url(${value})`, cursor: "pointer" }}>

                                    </span>
                                    <p className="TheText" style={{ margin: 0 }}>
                                        <span
                                            onClick={() => {
                                                Swal.fire({

                                                    imageUrl: value,
                                                    imageWidth: 450,
                                                    imageAlt: 'A tall image',
                                                    showCloseButton: true,
                                                    title: "Measurement",
                                                    allowEscapeKey: true,
                                                    allowOutsideClick: true,
                                                })
                                                // setImageToEdit(value)
                                                // setIndexToEdit(index)
                                                // setStep(6)
                                            }}
                                        >
                                            {/* Edit Picture */}
                                            {
                                                index % 2 == 0 ? "First Image" : "Second Image"
                                            }
                                        </span>

                                    </p>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        )
    }

    if (Step === 2 || Step === 4 || Step === 6 && ImageToEdit) {
        return (
            <EditingScreenShot
                Step={Step}
                IsLoading={IsEditorLoading}
                SelectedID=""
                onSave={() => {
                    if (Step === 2) {
                        saveFirstScreenShot()
                    }
                    if (Step === 4) {
                        saveSecondImage()
                    }
                    if (Step === 6) {
                        EditPicture()
                    }
                }}
                onSelectAnotherPicture={() => {
                    setStep(Step - 1)
                    setImageToEdit("")
                    if(Step !== 4){
                        EventBus.emit(EventBus.PICK_VERSION, 0);

                    }


                }}
                theImg={ImageToEdit}
                isFromRom={true}
                setAngle={(e) => setAngle(e)}
            />
        )
    }

    return (
        <div className="ManualRomContainer">
            {/* {
                Step == 1 ? (
                    <> */}
            <p className="Restart">
                Range of motion Evaluation <span style={{ cursor: "pointer" }} onClick={() => {
                    setStep(1)
                    setImageToEdit("")
                    setImageList([])
                    setIsEditorLoading(false)
                    props.exitManualRom()
                }}>(Click here to restart again)</span>
            </p>
            <div className="theMainHead">
                <h1>
                    Step {Step === 1 ? 1 : 2}
                </h1>
                <p>
                    {
                        Step == 1 ? `Get in the starting position and when you are ready click the "Take Picture" Button.` : `Get in the  position and when you are ready click the "Take Picture" Button.`
                    }
                </p>
                <div className="imgContainer" style={{backgroundImage:`url(${Step == 1 ? "/images/gagan0.jpg" : "/images/gagan2.jpg"})`}}>

                </div>

                <button
                    onClick={() => Step == 1 ? takingFirstImage() : takingSecondImage()}
                    className="TakePicture">
                    Take Picture
                </button>
            </div>
            <div className="theBottomHead">
                {/* <Button color="primary">
                    Next
                    </Button> */}
            </div>
            {/* </>
                ) : null
            } */}

        </div>
    )
}

export default ManualRomContainer
